import { render, staticRenderFns } from "./slot3.vue?vue&type=template&id=64400b39&scoped=true&"
import script from "./slot3.vue?vue&type=script&lang=js&"
export * from "./slot3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64400b39",
  null
  
)

export default component.exports